import { render, staticRenderFns } from "./OrgStaffParalegalStats.vue?vue&type=template&id=5c8fb439&scoped=true&"
import script from "./OrgStaffParalegalStats.vue?vue&type=script&lang=js&"
export * from "./OrgStaffParalegalStats.vue?vue&type=script&lang=js&"
import style0 from "./OrgStaffParalegalStats.vue?vue&type=style&index=0&id=5c8fb439&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8fb439",
  null
  
)

export default component.exports